export default __webpack_public_path__ + "static/media/custom-template.683f18c8.webp";